import { IPaymentRequest } from './payment.request';

export interface IOrderRequest extends IPaymentRequest {
  /** @deprecated: Use payment.paymentMethodId instead */
  id: string;
  products: { productId: string, priceId: string, quantity: number }[];
  payment?: { paymentMethodId: string };
}
